import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { ModalOptions, ModalService } from "@front/m19-ui";
import { BoardDebugInfoModalComponent } from "@m19-board/containers/board-layout/board-debug-info-modal.component";
import { AuthService } from "@front/m19-services";
import { M19BoardEnvironment } from "@front/m19-models/M19BoardEnvironment";

@Injectable({
  providedIn: "root",
})
export class EnvironmentService {
  private readonly authService = inject(AuthService);
  private readonly modalService = inject(ModalService);

  readonly isLocal = environment.isLocal;
  readonly isAdminLogin = this.authService.isAdminLogin();
  readonly showDemoEnvWarning = !environment.production;
  readonly showProdEnvWarning = environment.production && this.isAdminLogin;

  getEnvironmentConfig(): M19BoardEnvironment {
    return environment;
  }

  printDebugInfo() {
    const modalOptions: ModalOptions<null> = {
      modalTitle: "Debug Information",
      modalTitleIcon: "bug",
      position: "center",
    };
    this.modalService.openModal(BoardDebugInfoModalComponent, modalOptions);
  }
}
